const BenefitsListFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for benefits (e.g. 'Why Choose Us')",
      seo: true,
      key: "benefits.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction (15-20 words)",
      seo: false,
      key: "benefits.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Grid Cards", value: "grid" },
      { label: "Simple List", value: "list" },
      { label: "Centered Inline", value: "centered" },
    ],
    metadata: {
      source: "manual",
    },
  },
  iconStyle: {
    type: "radio",
    label: "Icon Style",
    options: [
      { label: "Checkmark", value: "check" },
      { label: "Check Circle", value: "checkCircle" },
      { label: "Star", value: "star" },
      { label: "Custom per Item", value: "custom" },
    ],
    metadata: {
      source: "manual",
    },
  },
  columns: {
    type: "radio",
    label: "Columns (Grid Only)",
    options: [
      { label: "1 Column", value: "1" },
      { label: "2 Columns", value: "2" },
      { label: "3 Columns", value: "3" },
      { label: "4 Columns", value: "4" },
    ],
    metadata: {
      source: "manual",
    },
  },
  benefits: {
    type: "array",
    label: "Benefits",
    metadata: {
      source: "ai",
      description: "List of benefits/features",
      seo: true,
      key: "benefits.list",
    },
    getItemSummary: (item: { text: string }) => item.text?.slice(0, 40) || "New Benefit",
    arrayFields: {
      text: {
        type: "text",
        label: "Benefit Text",
        metadata: {
          description: "Short benefit statement",
        },
      },
      icon: {
        type: "text",
        label: "Custom Icon (optional)",
        metadata: {
          description: "Lucide icon name (e.g., 'Shield', 'Clock', 'Award')",
        },
      },
    },
    defaultItemProps: {
      text: "New benefit",
      icon: "",
    },
  },
  accentColor: {
    type: "text",
    label: "Accent Color (optional)",
    metadata: {
      source: "manual",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;

export { BenefitsListFields };
